import { createSlice } from '@reduxjs/toolkit';

interface PlaygroundMessage {
  [key: string]: unknown;
}

// A playground chat as stored per project.
export interface PlaygroundData {
  _id?: string;
  status?: string;
  messages?: PlaygroundMessage[];
  [key: string]: unknown;
}

interface PlaygroundState {
  PLAYGROUND_PREFIX: string;
  playground: Record<string, PlaygroundData | null>;
}

const initialState: PlaygroundState = {
  PLAYGROUND_PREFIX: 'default_',
  playground: {},
};

export const playgroundSlices = createSlice({
  name: 'playgroundSlices',
  initialState,
  reducers: {
    setPlayground(state, action) {
      const { prefix, projectId, playground } = action.payload;

      state.playground[`${prefix || state.PLAYGROUND_PREFIX}${projectId}`] = playground;
    },
    clearPlayground: (state, action) => {
      const { prefix, projectId } = action.payload;

      state.playground[`${prefix || state.PLAYGROUND_PREFIX}${projectId}`] = null;
    },
    appendPlaygroundMessages(state, action) {
      const { prefix, projectId, messages } = action.payload;
      const projectPlayground =
        state.playground[`${prefix || state.PLAYGROUND_PREFIX}${projectId}`];

      projectPlayground.messages = projectPlayground.messages || [];

      state.playground[`${prefix || state.PLAYGROUND_PREFIX}${projectId}`] = {
        ...projectPlayground,
        messages: [...projectPlayground.messages, ...messages],
      };
    },
    updateLastPlaygroundMessage(state, action) {
      const { prefix, projectId, message } = action.payload;
      const projectPlayground =
        state.playground[`${prefix || state.PLAYGROUND_PREFIX}${projectId}`];
      const messages = projectPlayground.messages || [];

      if (message === null) {
        messages.length = messages.length - 2;
      } else {
        messages[projectPlayground.messages.length - 1] = message;
      }

      state.playground[`${prefix || state.PLAYGROUND_PREFIX}${projectId}`] = {
        ...projectPlayground,
        messages,
      };
    },
  },
});

export const {
  setPlayground,
  appendPlaygroundMessages,
  updateLastPlaygroundMessage,
  clearPlayground,
} = playgroundSlices.actions;

export default playgroundSlices.reducer;
